/** @jsxImportSource @emotion/react */

import IconButton from "@mui/material/IconButton";
import { CrossIcon } from "./BonusXIcons/CrossIcon";
import { BoxRightAlignament } from "./BoxRightAlignament";

interface CloseButtonComponentInterface {
  onClick?: () => void;
  className?: string;
  color?: string;
}

export function CloseButton({ onClick, className, color, ...rest }: Readonly<CloseButtonComponentInterface>) {
  return (
    <IconButton onClick={onClick} className={className} {...rest}>
      <CrossIcon width={18} height={18} color={color} />
    </IconButton>
  );
}

export function CloseButtonRightAlign(props: Readonly<CloseButtonComponentInterface>) {
  return (
    <BoxRightAlignament>
      <CloseButton {...props} />
    </BoxRightAlignament>
  );
}
